<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultBackHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Amortization Calculator</ion-title>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  <form [formGroup]="form" (ngSubmit)="calculate()">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="$"
          inputmode="decimal"
          type="text"
          formControlName="amount"
          [maskito]="amountMask"
          [maskitoElement]="maskPredicate"
        >
          <div slot="label">Amount:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="%"
          inputmode="decimal"
          type="text"
          formControlName="interestRate"
          [min]="0"
          [max]="100"
          [maskito]="rateMask"
          [maskitoElement]="maskPredicate"
        >
          <div slot="label">Interest Rate:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <red-searchable-select
        redErrorMessage
        [redRequired]="true"
        formControlName="mortgageTerm"
        [options]="mortgageTermData"
        placeholder="Select mortgage length"
        searchPlaceholder="Search mortgage length..."
      >
        <span searchable-select-label class="tw:whitespace-normal">
          Mortgage Length
          <ion-text color="danger">*</ion-text>
        </span>
      </red-searchable-select>
    </ion-list>
  </form>

  <ion-button class="tw:m-4" expand="block" (click)="calculate()">
    Calculate
    <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
  </ion-button>
</red-page-content>
